import React from 'react'
import { Link } from 'react-router-dom'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from '../style'

export const TicketMessage = props => {
  return (
    <Row
      className={css(
        style.tickets.message,
        style[props.theme.name] ? style[props.theme.name].tickets.message : null
      )}
      onMouseOver={e => props.onHover(props.id)}
      onMouseOut={e => props.onHover(null)}
    >
      {!props.user ? null : (
        <Col
          xs='12'
          style={{ opacity: +props.hoverState }}
          className={`d-flex align-items-center
            ${props.agent ? `justify-content-start` : `justify-content-end`}
          `}
        >
          {props.isMod ? (
            <Link
              to={`/dashboard/user/${props.user.id}`}
              className={css(style.tickets.authorSpan)}
            >
              {`${props.user.firstName} ${props.user.lastName}`}
            </Link>
          ) : (
            <span className={css(style.tickets.authorSpan)}>
              {`${props.user.firstName} ${props.user.lastName}`}
            </span>
          )}
        </Col>
      )}
      <Col
        xs='12'
        className={`
        d-flex align-items-center
        ${props.agent ? `justify-content-start` : `justify-content-end`}
      `}
      >
        <p
          className={css(
            style.paragraphs.p,
            style.tickets.p,
            style.tickets.reply,
            style[props.theme.name]
              ? style[props.theme.name].tickets.reply
              : null,
            props.agent ? null : style.tickets.otherUser
          )}
        >
          {props.content}
        </p>
      </Col>
    </Row>
  )
}

export default TicketMessage



// WEBPACK FOOTER //
// ./src/components/Support/partials/TicketMessage.js